import { IUser } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const userApi = crudEndpointsFactory<IUser>()('users', 'Users');
